<script lang="ts">
import { isPermittedSimple } from '@/modules/user/permissions'

import { defineComponent, SetupContext, computed } from 'vue'

export default defineComponent({
  props: {
    permissions: Array,
  },
  setup(props: { permissions: string[] }, { slots }: SetupContext) {
    const hasAccess = computed(() => {
      return isPermittedSimple(props.permissions)
    })
    return () =>
      slots.default?.({
        hasAccess: hasAccess.value,
      })
  },
})
</script>
